import { useQuery } from "@apollo/client";
import { QR_GET_TRIP_RESERVATION } from "../graphQl/MyTripsAPI";

export const useReservation = (tripReservationId) => {
  const { data, loading, error, refetch } = useQuery(
    QR_GET_TRIP_RESERVATION,
    {
      variables: { tripReservationId },
      skip: !tripReservationId,
      fetchPolicy: "network-only",
    }
  );

  const response = data?.QR_GET_TRIP_RESERVATION;

  return {
    loading,
    error: response?.error ?? error,
    code: response?.code,
    reservation: response?.data,
    refetch,
  };
};
